// Copyright (c) 2016 Deere & Company

import AppContainer from '../app/state-connector';

export default {
    component: AppContainer,
    name: 'HOME',
    path: '/'
};




// WEBPACK FOOTER //
// ./src/routes/app.js